module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('iframe', {
    attrs: {
      "id": "iframeContain",
      "name": "iframeContain",
      "seamless": "",
      "scrolling": "yes",
      "src": "http://emall.laoban100.com/onlinemall/message"
    }
  }, [_vm._v("\n      您当前的浏览器不支持页面上的功能，请升级您当前的浏览器版本或使用谷歌浏览器访问当前页面\n   ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47966b5b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tabs/2021-11-11/index.vue
// module id = 1041
// module chunks = 2